function BaseSelectionLabel({ name }) {
  return (
    <div className="
      py-0.5
      text-sm sm:text-base md:text-lg lg:text-xl
      text-center text-white font-semibold
      bg-yellow
      border-yellow border-x-2 border-t-2
      rounded-t-md sm:rounded-t-xl
    ">
      {name}
    </div>
  );
}

export default BaseSelectionLabel;
